import { render, staticRenderFns } from "./SearchAutocomplete.vue?vue&type=template&id=537cb3f3&scoped=true&"
import script from "./SearchAutocomplete.vue?vue&type=script&lang=js&"
export * from "./SearchAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./SearchAutocomplete.vue?vue&type=style&index=0&id=537cb3f3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537cb3f3",
  null
  
)

export default component.exports